import axios from 'axios';
const apiUrl = process.env.REACT_APP_API_URI || 'http://localhost:5000/api/';

const axiosClient = axios.create({
    baseURL: `${apiUrl}`,
    headers: {
        'content-type': 'application/json',
    },
});

axiosClient.interceptors.request.use(async (config) => {
    const customHeaders = {
        Authorization: '',
    };

    const token = localStorage.getItem('access_token');
    if (token) {
        customHeaders.Authorization = `Bearer ${token}`;
    }

    return {
        ...config,
        headers: {
            ...customHeaders, // auto attach token
            ...config.headers, // but you can override for some requests
        },
    };
});

axiosClient.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        // console.error(error.response, "interceptors Error")
        if (error.response.status === 401) {
            localStorage.removeItem('access_token');
            window.location.href = '/login';
        } else {
            throw error.response;
        }
    },
);

export default axiosClient;
